export default __webpack_public_path__ + "static/media/homer1.0a6ef551.png";